









































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Models
import Category from '@/models/Category'

// Components
import Box from '@/components/common/Box.vue'
import ImageViewer from '@/components/common/ImageViewer.vue'

@Component({
  components: {
    Box,
    ImageViewer
  }
})
export default class TemplateCategoriesBox extends Vue {
  categories = []
  subCategories = []
  templates = []

  category = null
  subCategory = null
  template = null

  isLoading = false
  step = 1
  selectedCategory = null
  selected = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  @Watch('template')
  emitEvent() {
    this.$emit('select', {
      category: this.category,
      subCategory: this.subCategory,
      template: this.template
    })
  }

  async mounted() {
    try {
      this.isLoading = true
      const res = await this.$api.templates.fetchTemplatesByCategory(this.token)
      this.categories = res.data.length ? res.data.map((item) => new Category(item, this.locale)) : []
    } finally {
      this.isLoading = false
    }
  }

  get stepTitle() {
    if (this.step === 1) {
      return this.$t('missions.new.breadcrumb.1.subtitle')
    }
    if (this.step === 2) {
      return this.$t('missions.new.breadcrumb.2.subtitle')
    }
    if (this.step === 3) {
      return this.$t('missions.new.breadcrumb.3.subtitle')
    }
  }

  get currentCagories() {
    if (this.step === 1) {
      return this.categories
    }
    if (this.step === 2) {
      return this.subCategories
    }
  }

  goToStep(step) {
    this.templates = []
    this.step = step
  }

  selectCategory(item) {
    this.step++

    if (this.step === 2) {
      this.category = item
      this.subCategories = item.subCategories
    }
    if (this.step === 3) {
      this.subCategory = item
      this.templates = item.templates
    }
  }

  selectTemplate(template) {
    this.template = template
  }
}
